import { render, staticRenderFns } from "./message-send-box.vue?vue&type=template&id=fd704be2&scoped=true"
import script from "./message-send-box.vue?vue&type=script&lang=js"
export * from "./message-send-box.vue?vue&type=script&lang=js"
import style0 from "./message-send-box.vue?vue&type=style&index=0&id=fd704be2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd704be2",
  null
  
)

export default component.exports